"use client";

import { cn } from "utils/functions";
import { sectionPaddingBottomClass, sectionPaddingTopClass } from "utils/sectionSpacingConstants";
import WhyLowCodeV2 from "./WhyLowCodeV2";
import { AssetFragment } from "contentful/gql/graphql";
import ConversionPanelV3 from "components/ConversionPanel/ConversionPanelV3";

type LowCodeForDevsType = {
  componentType: string;
  type: string;
  content: any[] | undefined;
  assets: (AssetFragment | undefined)[] | undefined;
  cardType: string | undefined;
};

export default function LowCodeForDevsV2({
  id,
  json,
  assets,
  testimonial,
}: {
  id: string;
  json: {
    componentTheme: string;
    paddingTop: string;
    paddingBottom: string;
    content: LowCodeForDevsType[] | undefined;
    description?: string;
    blured?: boolean;
  };
  assets: (AssetFragment | undefined)[] | undefined;
  testimonial: React.ReactNode;
}) {
  return (
    <>
      <section>
        <div className="container mx-auto max-w-screen-lg px-md py-lg md:px-xl md:py-xl">
          <div className="flex flex-col gap-xs">
            <p className="text-center text-lg">{json.description}</p>
          </div>
        </div>
      </section>
      <section
        id={id}
        style={{
          filter: json.blured ? "blur(7px)" : "none",
        }}
        className={cn(
          json.componentTheme?.toLowerCase() == "dark"
            ? "dark bg-primary-dark-900 text-primary-neutral-100"
            : "bg-primary-neutral-50 text-primary-dark-800",
        )}
      >
        <div
          className={cn(
            "container mx-auto",
            sectionPaddingTopClass[(json?.paddingTop as keyof typeof sectionPaddingTopClass) ?? "Medium"],
            sectionPaddingBottomClass[(json?.paddingBottom as keyof typeof sectionPaddingTopClass) ?? "Medium"],
            "flex flex-col gap-xs",
          )}
        >
          {json.content?.map((item, index) => {
            switch (item.componentType) {
              case "why-low-code":
                return (
                  <WhyLowCodeV2
                    key={`LowCodeDevs${item.componentType}-${index}`}
                    json={item.content}
                    type={item.type}
                  />
                );
              case "cta-card":
                const data: any = {};
                if (item.content?.[0]?.elementLink) {
                  data["callToActionCollection"] = {
                    items: [item.content?.[0]?.elementLink],
                  };
                }
                return (
                  <div className="flex flex-col gap-md pb-lg">
                    {testimonial}
                    <ConversionPanelV3
                      key={`LowCodeDevs${item.componentType}-${index}`}
                      variation={"dark"}
                      heading={item.content?.[0]?.elementTitle || ""}
                      headingType={"H3"}
                      {...data}
                      // accentImage={accentImage}
                    />
                  </div>
                );
              default:
                return null;
            }
          })}
        </div>
      </section>
    </>
  );
}
